<button
  type="button"
  (click)="onOpen()"
  class="group flex w-full cursor-pointer flex-col overflow-hidden rounded-xl border border-border bg-card text-left shadow-sm transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
  [attr.aria-label]="'Open ' + handle() + ', ' + statusLabel()"
>
  <!-- Thumbnail: 9/14 per the design, with a scrim so white text stays legible -->
  <div class="relative w-full overflow-hidden bg-muted" style="aspect-ratio: 9 / 14">
    @if (thumbnailUrl()) {
      <img
        [src]="thumbnailUrl()"
        [alt]="'Thumbnail for ' + handle() + '&rsquo;s TikTok post'"
        loading="lazy"
        class="h-full w-full object-cover"
      />
    } @else {
      <div class="flex h-full w-full items-center justify-center bg-muted">
        <p class="m-0 text-xs text-muted-foreground">No thumbnail</p>
      </div>
    }

    <div
      aria-hidden="true"
      class="pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/75"
    ></div>

    <div class="absolute top-2 left-2">
      <p class="m-0" [class]="statusPillClass()">{{ statusLabel() }}</p>
    </div>

    <div class="absolute inset-x-3 bottom-3 flex flex-col gap-y-0.5">
      <p class="m-0 truncate text-sm font-bold text-white">{{ handle() }}</p>
      <div class="flex flex-row gap-x-3 text-xs font-semibold text-white/85">
        <p class="m-0 tabular-nums">{{ views() }} views</p>
        <p class="m-0 tabular-nums">{{ engagementRate() }} ER</p>
      </div>
    </div>
  </div>

  <div class="flex flex-col gap-y-1 px-3 pt-2.5 pb-3">
    @if (displayName()) {
      <p class="m-0 truncate text-sm font-semibold text-primary">{{ displayName() }}</p>
    }
    <p class="m-0 text-xs font-medium text-secondary">{{ postedAt() }}</p>
  </div>
</button>
